
<b-navbar>
	<template #brand>
		<b-navbar-item>
			<img
				src="https://cdn.sanity.io/images/sfw2ue5n/production/415524a49203f87a35a81b183eae47855cefc772-462x112.png?w=462&h=112&auto=format"
				srcset="
					https://cdn.sanity.io/images/sfw2ue5n/production/415524a49203f87a35a81b183eae47855cefc772-462x112.png?w=462&h=112&auto=format 320w,
					https://cdn.sanity.io/images/sfw2ue5n/production/415524a49203f87a35a81b183eae47855cefc772-462x112.png?w=462&h=112&auto=format 462w
				"
				alt="Cadpro"
				decoding="async"
				loading="lazy"
				tabindex="102"
			/>
		</b-navbar-item>
	</template>
	<template #start> </template>

	<template #end>
		<b-navbar-item tag="div">
			<a href="https://cadpro.io" tabindex="103"> Main site </a>
			<a href="https://cadpro.io" tabindex="103"> Back to main site </a>
		</b-navbar-item>
	</template>
</b-navbar>
